import type { ComponentChildren } from 'preact';
import type { EnglishCard } from '../types';
import { learnerLanguage, L1_META } from '../i18n/learner';

export function EnglishCardBack({ card }: { card: EnglishCard }): ComponentChildren {
  const lang = learnerLanguage.value;
  const t = card.wordTranslations?.[lang];
  const fontClass = L1_META[lang].fontClass ?? '';
  return (
    <div>
      <div className="text-2xl">{card.back}</div>
      {/* No L1 line when translation is missing for current learner language —
          intentional silent fallback during incremental rollout. */}
      {t && (
        <div className="mt-4 pt-4 border-t">
          <div className={`text-3xl ${fontClass}`}>{t.meaning}</div>
          {t.reading && (
            <div className={`text-lg opacity-70 ${fontClass}`}>{t.reading}</div>
          )}
        </div>
      )}
      <div className="mt-4 italic">"{card.example.sentence}"</div>
    </div>
  );
}
